import { createFileRoute } from '@tanstack/react-router'
import { Split } from 'lucide-react'
import { RoutingScreen } from '@/screens/connect/SCR-041-routing'

export const Route = createFileRoute('/_app/connect/routing')({
  staticData: { screen: { id: 'SCR-041', title: 'Model routing', group: 'Connect', perm: 'model.manage', order: 10, description: 'Which model handles which job, and where it runs. What you request is kept; what runs today is shown as it is.', icon: Split } },
  component: RoutingScreen,
})
